import { useAtom } from "jotai";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { authAtom } from "../../auth/auth.atom";
import { axios } from "../../axios";
import styled from "styled-components";
import { UserInterface } from "../../interfaces/user.interface";
import { User } from "../../models/User";
import { config } from "../../config";
import { usePreserveQueryParamsNavigate } from "../../hooks/usePreserveQueryParamsNavigate";
import { wait } from "../../utils/wait";
import { useNavigateToRedirect } from "../../utils/navigateToRedirect";
import { needsVerification } from "../../utils/verification";

export const HomePage = () => {
  const [query] = useSearchParams();
  const [auth, setAuth] = useAtom(authAtom);
  const navigate = usePreserveQueryParamsNavigate();
  const navigateToRedirect = useNavigateToRedirect();

  useEffect(() => {
    if (auth.loaded && auth.authenticated && !needsVerification(auth.user)) {
      if (query.get("is_mobile_webview") === "true") {
        wait(2000).then(() => {
          const link = document.createElement("a");
          link.href = `pocketfilms://?token=${sessionStorage.getItem(
            "tmp_token"
          )}`;
          link.click();
          // window.open(
          //   `pocketfilms://?token=${sessionStorage.getItem("tmp_token")}`
          // );
        });
      } else {
        navigateToRedirect();
      }
    } else if (auth.loaded && !auth.authenticated) {
      navigate("/login");
    } else if (auth.loaded && auth.authenticated) {
      navigate("/verify");
    }
  }, [auth, query]);

  useEffect(() => {
    if (auth.loaded) return;
    axios
      .get<{ user: UserInterface }>("/auth/user/me")
      .then((result) => {
        if (result.status === 200) {
          setAuth({
            authenticated: true,
            user: User.fromJson(result.data.user ?? result.data),
            loaded: true,
          });
        } else {
          throw new Error();
        }
      })
      .catch(() => {
        setAuth({ authenticated: false, user: null, loaded: true });
      });
  }, []);

  return (
    <Container>
      <LoadingText>Loading...</LoadingText>
    </Container>
  );
};

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingText = styled.h2`
  font-size: 2.5rem;
  color: #fff;
  font-weight: 600;
  animation: pulseOpacity 2s infinite both ease-in-out;

  @keyframes pulseOpacity {
    0% {
      opacity: 100%;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 100%;
    }
  }
`;
